import posthog from "posthog-js";

type Event =
  | { event: "SIGN_UP"; data: { email?: string } }
  | { event: "ONBOARDING_COMPLETED" }
  | { event: "VARIANT_CREATED" }
  | { event: "VARIANT_CHAT_MESSAGE_SENT" }
  | { event: "TRAFFIC_SOURCE_CREATED" }
  | { event: "CONVERSION_RULE_CREATED" }
  | { event: "CLIENT_ERROR"; data: { traceId?: string } };

export class Tracking {
  static capture(event: Event) {
    posthog.capture(event.event, "data" in event ? event.data : undefined);
  }
}

export class RedditTracking {
  // Reddit accepts only a set of predefined events, SignUp is one of them
  // For more, see: https://docs.tealium.com/client-side-tags/reddit-pixel-tag/#events
  static track(event: { event: "SignUp"; conversionId?: string }) {
    (window as { rdt?: any }).rdt?.(
      "track",
      event.event,
      event.conversionId ? { conversion_id: event.conversionId } : undefined,
    );
  }
}
